/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import { loadFonts } from './webfontloader'
import router from '@/router/index.js'
import globalFunctions from './globalFunctions' 
import vuetify from './vuetify'
import PdfPlugin from '@/plugins/pdf';
import xlsxPlugin from '@/plugins/xlsxPlugin'; 
import csvPlugin from '@/plugins/csvPlugin'; // Assuming you have a csvPlugin
export function registerPlugins (app) {
  loadFonts()
  app.use(router)
  app.use(vuetify)
  app.use(globalFunctions)
  app.use(PdfPlugin)
  app.use(xlsxPlugin)
  app.use(csvPlugin)
}
